const BiometricsIcon = ({
  size = 114
}: {
  size?: number
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 114 114" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="57" cy="57" r="57" fill="url(#paint0_linear_8708_51624)"/>
      <circle cx="56.9999" cy="57" r="50.2143" fill="url(#paint1_linear_8708_51624)"/>
      <circle cx="56.9999" cy="57" r="49.7143" stroke="#FEFEFE" strokeOpacity="0.3"/>
      <path d="M33 48V41C33 35.4772 37.4772 31 43 31H48" stroke="white" strokeWidth="3.5" strokeLinecap="round"/>
      <path d="M81 66V73C81 78.5228 76.5228 83 71 83H66" stroke="white" strokeWidth="3.5" strokeLinecap="round"/>
      <path d="M81 48V41C81 35.4772 76.5228 31 71 31H66" stroke="white" strokeWidth="3.5" strokeLinecap="round"/>
      <path d="M33 66V73C33 78.5228 37.4772 83 43 83H48" stroke="white" strokeWidth="3.5" strokeLinecap="round"/>
      <path d="M48 66L51.2009 67.2448C54.9309 68.6953 59.0691 68.6953 62.7991 67.2448L66 66" stroke="white" strokeWidth="3" strokeLinecap="round"/>
      <path d="M48 47L48 53" stroke="white" strokeWidth="3" strokeLinecap="round"/>
      <path d="M66 47L66 53" stroke="white" strokeWidth="3" strokeLinecap="round"/>
      <path d="M57 56L57 60" stroke="white" strokeWidth="3" strokeLinecap="round"/>
      <defs>
        <linearGradient id="paint0_linear_8708_51624" x1="-3.648" y1="-5.55782" x2="142.088" y2="93.1496" gradientUnits="userSpaceOnUse">
          <stop offset="0.065" stopColor="#C9ECFF"/>
          <stop offset="0.36" stopColor="#50A2FF"/>
          <stop offset="0.67" stopColor="#7B69FF"/>
          <stop offset="0.94" stopColor="#9B1BFF"/>
        </linearGradient>
        <linearGradient id="paint1_linear_8708_51624" x1="3.57193" y1="1.88953" x2="131.959" y2="88.846" gradientUnits="userSpaceOnUse">
          <stop offset="0.065" stopColor="#C9ECFF"/>
          <stop offset="0.36" stopColor="#50A2FF"/>
          <stop offset="0.67" stopColor="#7B69FF"/>
          <stop offset="0.94" stopColor="#9B1BFF"/>
        </linearGradient>
      </defs>
    </svg>
  )
}

export default BiometricsIcon
